/* brotschule · botón de compra: AJAX al carrito, nunca URL directa */
(function(){
  var NS='brotschule';
  function conectar(){
    var id = window[NS+'_VARIANT_ID'];
    document.querySelectorAll('.'+NS+' .cta').forEach(function(b){
      var n=b.cloneNode(true); b.parentNode.replaceChild(n,b);   /* mata handlers viejos del cache */
      n.addEventListener('click',function(e){
        e.preventDefault();
        if(!id){ console.error('['+NS+'] falta VARIANT_ID en la seccion 00-cargador'); return; }
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:id,quantity:1})})
          .then(function(r){ if(!r.ok) throw new Error(r.status); window.location='/cart'; })
          .catch(function(err){ console.error('['+NS+'] no se pudo agregar al carrito',err); });
      });
    });
    document.querySelectorAll('.'+NS+' img').forEach(function(i){
      i.addEventListener('error',function(){
        i.classList.add('vacio');
        i.insertAdjacentHTML('afterend','<span class="falta">FALTA SUBIR: '+
          (i.getAttribute('src')||'').split('/').pop().split('?')[0]+'</span>');
      });
    });
  }
  if(document.readyState!=='loading') conectar(); else document.addEventListener('DOMContentLoaded',conectar);
})();
